import { render, staticRenderFns } from "./system_management_authority.vue?vue&type=template&id=7821df62&scoped=true"
import script from "./system_management_authority.vue?vue&type=script&lang=js"
export * from "./system_management_authority.vue?vue&type=script&lang=js"
import style0 from "./system_management_authority.vue?vue&type=style&index=0&id=7821df62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821df62",
  null
  
)

export default component.exports